import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useApolloClient, useMutation } from '@apollo/client';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { logOut } from '../../apollo/helpers/auth';
import REQUEST_PASSWORD_CHANGE_EMAIL from '../../graphql/mutations/request-password-change-email';
import FingoDialog from '../dialogs/FingoDialog';


const PasswordChangeRequiredNotice = ({ email }) => {
  const client = useApolloClient();
  const requested = useRef(false);

  const [requestPasswordChangeEmail] = useMutation(REQUEST_PASSWORD_CHANGE_EMAIL, {
    onError: () => {},
  });

  useEffect(() => {
    if (requested.current) return;
    requested.current = true;
    requestPasswordChangeEmail();
  }, [requestPasswordChangeEmail]);

  return (
    <FingoDialog
      open
      handleClose={() => {}}
      hideCloseButton
      disableEscapeKeyDown
      maxWidth={480}
      fullWidth
      title="Debes actualizar tu contraseña"
    >
      <Stack spacing={2}>
        <Alert severity="warning">
          Por seguridad tu contraseña quedó bloqueada y no puedes seguir usando la
          plataforma hasta cambiarla.
        </Alert>
        <Typography variant="body2">
          Te enviamos un correo a <strong>{email}</strong> con un link para crear una
          contraseña nueva. Por seguridad el cambio se hace solo desde ese correo, no
          desde acá.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          El link vence en 5 horas. Si no lo encuentras, revisa tu carpeta de spam.
        </Typography>
        <Stack direction="row" justifyContent="flex-end">
          <Button variant="contained" color="primary" onClick={() => logOut(client)}>
            Cerrar sesión
          </Button>
        </Stack>
      </Stack>
    </FingoDialog>
  );
};

PasswordChangeRequiredNotice.propTypes = {
  email: PropTypes.string,
};

PasswordChangeRequiredNotice.defaultProps = {
  email: '',
};

export default PasswordChangeRequiredNotice;
